import { h } from 'preact';
import { useState } from 'preact/hooks';

export default function AddressValidationModal({
  currentAddress,
  recommendedAddress,
  onSelectAddress,
  onClose
}) {
  const [selectedOption, setSelectedOption] = useState('recommended');

  const handleConfirm = () => {
    const addressToUse = selectedOption === 'current' ? currentAddress : recommendedAddress;
    onSelectAddress(addressToUse);
  };

  const formatAddress = (address) => {
    const parts = [];
    if (address.address) parts.push(address.address);
    if (address.address_2) parts.push(address.address_2);
    if (address.city && address.state_province && address.postal_code) {
      parts.push(`${address.city}, ${address.state_province} ${address.postal_code}`);
    }
    return parts;
  };

  const currentAddressParts = formatAddress(currentAddress);
  const recommendedAddressParts = formatAddress(recommendedAddress);

  return (
    <div
      className="address-validation-modal fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
        <div className="text-2xl font-bold mb-4">Verify Your Address</div>
        <p className="mb-6 text-gray-600">
          We found a recommended address that may be more accurate. Please select which address you'd like to use.
        </p>

        <div className="flex flex-col gap-4 mb-6">
          {/* Keep Current Address Option */}
          <label
            className={`block p-6 border-4 rounded-lg cursor-pointer transition-all ${
              selectedOption === 'current'
                ? 'border-coit-success bg-opacity-5'
                : 'border-gray-300 hover:border-coit-success'
            }`}
          >
            <div className="flex items-start gap-4">
              <input
                type="radio"
                name="addressOption"
                value="current"
                checked={selectedOption === 'current'}
                onChange={(e) => setSelectedOption(e.target.value)}
                className="mt-1 w-5 h-5"
              />
              <div className="flex-1">
                <div className="text-lg font-semibold mb-2">Keep the Current Address</div>
                {currentAddressParts.map((line, index) => (
                  <div key={index} className="text-gray-700">{line}</div>
                ))}
              </div>
            </div>
          </label>

          {/* Use Recommended Address Option */}
          <label
            className={`block p-6 border-4 rounded-lg cursor-pointer transition-all ${
              selectedOption === 'recommended'
                ? 'border-coit-success bg-opacity-5'
                : 'border-gray-300 hover:border-gray-400'
            }`}
          >
            <div className="flex items-start gap-4">
              <input
                type="radio"
                name="addressOption"
                value="recommended"
                checked={selectedOption === 'recommended'}
                onChange={(e) => setSelectedOption(e.target.value)}
                className="mt-1 w-5 h-5 text-coit-primary focus:ring-coit-primary"
              />
              <div className="flex-1">
                <div className="text-lg font-semibold mb-2">Use the Recommended Address</div>
                {recommendedAddressParts.map((line, index) => (
                  <div key={index} className="text-gray-700">{line}</div>
                ))}
              </div>
            </div>
          </label>
        </div>

        <div className="flex gap-4 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="coit-button-outline"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="coit-button"
          >
            Confirm Address
          </button>
        </div>
      </div>
    </div>
  );
}
